// extracted by mini-css-extract-plugin
export var arrow = "Pagination-module--arrow--a2xaM";
export var disabled = "Pagination-module--disabled--foWV1";
export var dots = "Pagination-module--dots--T5YlV";
export var left = "Pagination-module--left--2QfYm";
export var page404Title = "Pagination-module--page404-title--EkIsO";
export var paginationContainer = "Pagination-module--paginationContainer--xkKDz";
export var paginationItem = "Pagination-module--paginationItem--RoXuj";
export var right = "Pagination-module--right--xgtEX";
export var selected = "Pagination-module--selected--z4WwJ";